import { IMemberChoices } from '../api/models/memberchoice/memberchoice.types';
import { createAction } from '../helpers';

// TODO: use createAction everywhere in the file
export enum EMemberChoicesActionType {
  GET = 'MEMBER_CHOICES_GET',
  GET_SUCCESS = 'MEMBER_CHOICES_GET_SUCCESS',
  UPDATE = 'MEMBER_CHOICES_UPDATE',
  UPDATE_SUCCESS = 'MEMBER_CHOICES_UPDATE_SUCCESS',
  POST = 'MEMBER_CHOICES_POST',
}

export enum EValidateAnnounceActionType {
  PATCH = 'VALIDATE_ANNOUNCE_PATCH',
}

export interface IGetMemberChoicesPayload {
  accountId: string;
}

export interface IGetMemberChoicesAction {
  type: EMemberChoicesActionType.GET;
  payload?: IGetMemberChoicesPayload;
}

export const getMemberChoicesAction = (
  payload?: IGetMemberChoicesPayload
): IGetMemberChoicesAction => ({
  type: EMemberChoicesActionType.GET,
  payload: payload ? { accountId: payload.accountId } : undefined,
});

export interface IGetMemberChoicesSuccessPayload {
  accountId: string;
  values: IMemberChoices;
}

export interface IUpdateMemberChoicesAction {
  type: EMemberChoicesActionType.UPDATE;
  payload: IMemberChoices;
}

export interface IUpdateMemberChoicesSuccessAction {
  type: EMemberChoicesActionType.UPDATE_SUCCESS;
  payload: {
    accountId: string;
    values: IMemberChoices;
  };
}

export interface IGetMemberChoicesSuccessAction {
  type: EMemberChoicesActionType.GET_SUCCESS;
  payload: IGetMemberChoicesSuccessPayload;
}

export const getMemberChoicesSuccess = (
  payload: IGetMemberChoicesSuccessPayload
): IGetMemberChoicesSuccessAction => ({
  type: EMemberChoicesActionType.GET_SUCCESS,
  payload,
});

export interface IPostMemberChoicesAction {
  type: EMemberChoicesActionType.POST;
  payload: IMemberChoices;
}

export const postMemberChoicesAction = (
  payload: IMemberChoices
): IPostMemberChoicesAction => ({
  type: EMemberChoicesActionType.POST,
  payload,
});

export interface IPatchAnnounceAndValidateProfileCaptureAction {
  type: EValidateAnnounceActionType.PATCH;
  payload: string;
}

export const patchAnnounceAction = (
  payload: string
): IPatchAnnounceAndValidateProfileCaptureAction => ({
  type: EValidateAnnounceActionType.PATCH,
  payload,
});

export const updateMemberChoices = (payload: IMemberChoices) =>
  createAction(EMemberChoicesActionType.UPDATE, payload);

export const updateMemberChoicesSuccess = (
  values: IMemberChoices,
  accountId: string
) =>
  createAction(EMemberChoicesActionType.UPDATE_SUCCESS, {
    accountId,
    values,
  });

export type IMemberChoicesAction =
  | IGetMemberChoicesAction
  | IGetMemberChoicesSuccessAction
  | IPostMemberChoicesAction
  | IUpdateMemberChoicesAction
  | IUpdateMemberChoicesSuccessAction;
